import { useState } from "react";
import { ArrowDownAZIcon, XIcon } from "lucide-react";

import { Icon } from "@/components/atoms/Icon";
import { Popper } from "@/components/atoms/Popper";
import { SortChipContent } from "@/components/organisms/UtilityBar/SortChip/SortChipContent";
import { useSortChipState } from "@/components/organisms/UtilityBar/FilterChip/FilterChipStateContext";
import { Button } from "@/components/ui/button";
import { ButtonGroup } from "@/components/ui/button-group";
import { cn } from "@/components/ui/utils";

// Main component
export function SortChip() {
  const { sortables, sortableDefinitions, setSortables } = useSortChipState();
  const firstSortable = sortables?.[0];
  const [isNameOpen, setIsNameOpen] = useState(false);

  const isSortSet = sortables.length > 0;

  if (Object.keys(sortableDefinitions).length === 0) return null;

  // Its sort, a button - dashed while there is none, as a filter to add is -
  // and, set, its x: one of shadcn's button groups, as a filter chip is.
  return (
    <ButtonGroup>
      <Popper
        anchorLayout="button-group"
        isOpenState={[isNameOpen, setIsNameOpen]}
        isHoverable={false}
        isClickable={true}
        anchor={
          <Button
            variant="outline"
            size="sm"
            data-sort-chip="main"
            data-testid="sort-chip-main"
            className={cn(!isSortSet && "border-dashed text-muted-foreground")}
          >
            <Icon ReactIcon={ArrowDownAZIcon} />
            {isSortSet ? (
              <>
                <span className="text-muted-foreground">Sorted by</span>
                {sortableDefinitions[firstSortable?.key]?.name}
              </>
            ) : (
              "Sort"
            )}
          </Button>
        }
        floatingStyle={{ padding: 0 }}
      >
        <SortChipContent isOpenState={[isNameOpen, setIsNameOpen]} />
      </Popper>
      {isSortSet && (
        <Button
          variant="outline"
          size="icon-sm"
          aria-label="Clear sort"
          data-testid="sort-chip-close"
          onClick={(event) => {
            event.stopPropagation();
            setSortables([]);
            // Back on the sort, once it is drawn unset.
            requestAnimationFrame(() =>
              document
                .querySelector<HTMLElement>(`[data-sort-chip="main"]`)
                ?.focus(),
            );
          }}
        >
          <XIcon size="1em" />
        </Button>
      )}
    </ButtonGroup>
  );
}
